import styled from "vue-styled-components";

export const Content = styled.div`
    .card-body-custom {
        display: flex;
        justify-content: space-between;
        text-transform: capitalize;

        &:after {
            display: none;
        }
    }

    .card-header-left {
        p span {
            color: white;
            padding: 6px 15px;
            font-size: 13px;
        }

        .bg-warning {
            color: black;
        }
    }

    .card-header-right {
        text-align: end;
        margin:auto 0;
    }

    @media screen and (max-width: 465px) {
        .card-body-custom {
            flex-direction: column;
        }
    }
`;
